import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.wren = bracketIndenting()
